<template>
  <div id="Searchresult">
    <Header></Header>
    <div>
      <Goback></Goback>
      <a-row>
        <a-col>
          <div class="topbar">
            <a-col :span="3"> </a-col>
            <a-col :span="18">
              <div>
                <a-row class="searchbox" :gutter="20">
                  <a-col :span="12">
                    <div class="inputborder">
                      <input
                        class="searchtext"
                        v-model="searchdepart"
                        placeholder="部门"
                      />
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div class="inputborder">
                      <input
                        class="searchtext"
                        v-model="searchtext"
                        placeholder="姓名"
                      />
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div class="searchContainer">
                      <!-- <input
                        class="searchtext"
                        v-model="actBatchCode"
                        placeholder="批次"
                      /> -->
                      <a-select
                       class="searchtext"
                        placeholder="批次"
                        v-model="actBatchCode"
                      >
                        <a-select-option :value="undefined"
                          >请选择</a-select-option
                        >
                        <a-select-option
                          v-for="(item, key) in activecodelist"
                          :key="key"
                          :value="item"
                        >
                          <span
                            style="display: inline-block; width: 100%;line-hight:33px;"
                            :title="item"
                          >
                            {{ item }}
                          </span>
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-col>
                  <a-col class="textleft" :span="12">
                    <a-button
                      type="danger"
                      @click="getstuscore"
                      shape="round"
                      icon="search"
                      >查询</a-button
                    >
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </div>
          <div class="tableresult">
            <a-table
              class="pctable"
              :pagination="pagination"
              :data-source="data"
              :columns="columns"
              :loading="loading"
              :locale="{ text: '没有相关结果' }"
            >
              <template slot="action" slot-scope="record">
                <a @click="studetails(record)">查看详情</a>
              </template>
            </a-table>
            <a-table
              class="mobiletable"
              :pagination="mobilepagination"
              :data-source="data"
              :columns="mobilecolumns"
              :locale="{ text: '没有相关结果' }"
            >
              <template slot="action" slot-scope="record">
                <a @click="studetails(record)">详情</a>
              </template>
            </a-table>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header";
import Search from "@/components/Search/Search";
import Goback from "@/components/Goback/Goback";
import Axios from "@/Axios";
import infoAction from "@/utils";
import { message } from "ant-design-vue";
export default {
  name: "Searchresult",
  components: {
    Header,
    Search,
    Goback,
  },
  data() {
    return {
      activecodelist: [],
      text: "查看详情",
      loading: true,
      searchbatch: "",
      searchtext: "",
      actBatchCode: undefined,
      searchdepart: sessionStorage.getItem("searchdepart")
        ? sessionStorage.getItem("searchdepart")
        : "",
      url: {
        studentscore: "/tscore/yhaScore/page/studentscore",
      },
      // total:'',
      pagination: {
        pageNo: sessionStorage.getItem("studentpage")
          ? parseInt(sessionStorage.getItem("studentpage"))
          : 1,
        pageSize: sessionStorage.getItem("studentpageSize")
          ? parseInt(sessionStorage.getItem("studentpageSize"))
          : 30, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ["5", "10", "20", "50", "100"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: this.onShowSizeChange, // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: sessionStorage.getItem("studentpage")
          ? parseInt(sessionStorage.getItem("studentpage"))
          : 1,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
      },
      mobilepagination: {
        pageNo: 1,
        pageSize: 30, // 默认每页显示数量
        // showSizeChanger: true, // 显示可改变每页数量
        // pageSizeOptions: ["5", "10", "20", "50", "100"], // 每页数量选项
        // showTotal: (total) => `共${total}条`, // 显示总数
        // onShowSizeChange: this.onShowSizeChange, // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        // showQuickJumper:"123",
        // 表格跳转事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
      },
      data: [],
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
          align: "center",
        },
        {
          title: "部门",
          dataIndex: "department_text",
          key: "department_text",
          align: "center",
          alipsis: true,
        },
        // {
        //   title: "参与培训时间",
        //   dataIndex: "age",
        //   key: "4",
        //   alipsis: true,
        // },
        {
          title: "理论知识成绩",
          dataIndex: "theory_score",
          key: "theory_score",
          align: "center",
          alipsis: true,
        },
        {
          title: "理论评价",
          dataIndex: "theory_level",
          key: "theory_level",
          align: "center",
          alipsis: true,
          customRender: function (text) {
              if (text == 'excellent') {
                return "优秀";
              } else if (text == 'good') {
                return "良好";
              } else if (text == 'normal') {
                return "普通";
              } else if (text == 'bad') {
                return "不合格";
              } else if (text == 'undefined') {
                return "未知";
              } else {
                return "未知";
              }
            }
        },
        // {
        //   title: "实操成绩",
        //   dataIndex: "practice_score",
        //   key: "practice_score",
        //   align: "center",
        //   alipsis: true,
        // },
        // {
        //   title: "实操评价",
        //   dataIndex: "practice_level",
        //   key: "practice_level",
        //   align: "center",
        //   alipsis: true,
        // },
        {
          title: "灭火时间/s",
          dataIndex: "outfire_time",
          key: "outfire_time",
          align: "center",
          alipsis: true,
        },
        {
          title: "灭火评价",
          dataIndex: "fireout_level",
          key: "fireout_level",
          align: "center",
          alipsis: true,
          customRender: function (text) {
              if (text == 'excellent') {
                return "优秀";
              } else if (text == 'good') {
                return "良好";
              } else if (text == 'normal') {
                return "普通";
              } else if (text == 'bad') {
                return "灭火失败";
              } else if (text == 'undefined') {
                return "未知";
              } else {
                return "未知";
              }
            }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      mobilecolumns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
          align: "center",
          ellipsis: true,
          width: 80,
        },
        // {
        //   title: "部门",
        //   dataIndex: "department_text",
        //   key: "department_text",
        //   align: "center",
        //   alipsis: true,
        // },
        {
          title: "理论成绩",
          dataIndex: "theory_score",
          key: "theory_score",
          align: "center",
          alipsis: true,
          ellipsis: true,
          width: 75,
        },
        // {
        //   title: "理论评价",
        //   dataIndex: "theory_level",
        //   key: "theory_level",
        //   align: "center",
        //   alipsis: true,
        // },
        {
          title: "实操成绩",
          dataIndex: "practice_score",
          key: "practice_score",
          align: "center",
          alipsis: true,
          ellipsis: true,
          width: 75,
        },
        // {
        //   title: "实操评价",
        //   dataIndex: "practice_level",
        //   key: "practice_level",
        //   align: "center",
        //   alipsis: true,
        // },
        // {
        //   title: "灭火时间/s",
        //   dataIndex: "outfire_time",
        //   key: "outfire_time",
        //   align: "center",
        //   alipsis: true,
        //   ellipsis: true,
        //   width: 80,
        // },
        // {
        //   title: "灭火评价",
        //   dataIndex: "fireout_level",
        //   key: "fireout_level",
        //   align: "center",
        //   alipsis: true,
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 80,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  mounted() {
    console.log(this.pagination.pageNo);

    this.getstuscore();
    this.getactivelist()
  },
  methods: {
    // 通过单位id获取活动编码
    getactivelist() {
      let that = this
      Axios.get('/qrcode/yhaDigitalCode/activeCode', {
        params: {
          universityId: infoAction.getinfo("teacher_info").universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          that.activecodelist = res.data.result
        } else {
          console.log(res.data.message)
          // that.$message.info(res.data.message)
        }
      })
    },
    // 获取受训人员成绩列表
    getstuscore(
      pageNo = this.pagination.pageNo,
      pageSize = this.pagination.pageSize,
      studentname=this.searchtext,
      searchdepart = this.searchdepart
    ) {
      this.loading = true;
      Axios.get(this.url.studentscore, {
        params: {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          universityid: infoAction.getinfo("teacher_info").universityId,
          studentName: studentname,
          departmentName: searchdepart,
          actBatchCode: this.actBatchCode,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var result = res.data.result;
          this.data = result.records;
          this.pagination.total = result.total;
          this.mobilepagination.total = result.total;
          this.loading = false;
        } else {
          this.$message.info(res.data.message);
          this.loading = false;
        }
      });
    },
    //  切换表格页码
    onPageChange(page) {
      sessionStorage.setItem("studentpage", page);
      this.pagination.pageNo = page;
      this.pagination.current = page;
      this.getstuscore(
        this.pagination.current,
        this.pagination.pageSize,
        this.searchtext,
        this.searchdepart
      );
    },
    // 切换表格展示受训人员的数量
    onShowSizeChange(current, pageSize) {
      sessionStorage.setItem("studentpageSize", pageSize);
      // console.log(current, pageSize);
      this.pagination.pageSize = pageSize;
      this.getstuscore(current, pageSize);
    },
    // 搜索受训人员姓名
    // search() {
    //   this.pagination.current = 1;
    //   sessionStorage.setItem("searchdepart", this.searchdepart);
    //   this.getstuscore(
    //     this.pagination.current,
    //     this.pagination.pageSize,
    //     this.searchtext,
    //     this.searchdepart
    //   );
    // },
    // 查看受训人员详情
    studetails(data) {
      console.log(data);
      this.$router.push({
        path: "/studentdetails",
        query: {
          digital_id: data.digital_id,
          fireout_level: data.fireout_level,
          practice_score: data.practice_score,
          theory_score: data.theory_score,
          outfire_time: data.outfire_time,
          practice_level: data.practice_level
        },
      });
    },
  },
};
</script>
<style scoped>
.topbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 10px;
  height: 80px;
  border-bottom: 1px solid silver;
  /* line-height: 80px; */
}
.goback {
  text-align: left;
}
.tableresult {
  margin-top: 30px;
  box-shadow: 1px 4px 24px 0px rgba(45, 45, 44, 0.17);
}
.table {
  border-radius: 10px;
}
.ant-table-thead > tr > th {
  background-color: slateblue !important;
}
.searchbox {
  /* height: 5vh; */
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.searchContainer {
  background: #f1f1f1;
  border-radius: 50px;
}
.searchtext {
  outline: none;
  width: 96%;
  height: 80%;
  background-color: #f1f1f1;
  border: none;
  text-align: center;
  font-size: 13px;
}
.searchtext::-webkit-input-placeholder {
  text-align: center;
}
.searchtext >>> .ant-select-selection {
  background: #f1f1f1 !important;
  border: none !important;
}
.searchtext >>> .ant-select-selection__placeholder {
  top: 55%;
}
.inputborder {
  /* outline: none; */
  width: 100%;
  height: 5vh;
  font-size: 20px;
  background-color: #f1f1f1;
  border-radius: 4vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.textleft {
  text-align: left;
  margin-bottom: 10px;
}
.mobiletable {
  display: none;
}
@media screen and (max-width: 768px) {
  .pctable {
    display: none;
  }

  .mobiletable {
    display: block;
  }
  .inputborder {
    font-size: 16px;
  }
  .searchtext {
    width: 80%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Searchresult/Searchresult.vue